import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const LoginPasswordPage = () => {
    return (
        <div id="login-password-page">
            <div className="title-log-in xpr-2 xpl-2 xmb-5">
                <span>رمز عبور را وارد کنید</span>
            </div>
            <div className="description xpx-2 xmb-6">
                <p>رمز عبور حساب کاربری خود را وارد کنید</p>
            </div>
            <form id="form-password-login">
                <div className="position-relative xmb-6">
                    <input type="text" value="v.namevari.com" className="form-control input-normal"/>
                    <div className="email-icon position-absolute">
                        <IconName name="email" className="icon"/>
                    </div>
                    <div className="text-input position-absolute"><span>ویرایش</span></div>
                </div>
                <div className="position-relative xmb-8">
                    <input id="input-password-login" type="password" placeholder="رمز عبور خود را وارد کنید"
                           className="form-control input-normal"/>
                    <div className="password-icon position-absolute">
                        <IconName name="visibility" className="icon"/>
                    </div>
                    <div className="text-input position-absolute" id="recovery-password"><span>بازیابی رمز عبور</span></div>
                </div>
                <div className="button-log-in xmb-6">
                    <button type="submit">ورود</button>
                </div>
                <div id="login-one-time-code" className="phone-code-link xmb-2">
                    <span>ورود با رمز یک بار مصرف</span>
                </div>
            </form>
        </div>
    );
};

export default LoginPasswordPage;
